export enum StatoAnalisi {
  'APERTA',
  'INVIATA OFFERTA',
  'SUPERATA',
  'ANNULLATA',
  'COMPLETATA',
  'ORDINATA',
}
